var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "error_svg__a",
    d: "M12 5l4.95 2.05L19 12l-2.05 4.95L12 19l-4.95-2.05L5 12l2.05-4.95z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error_svg__a",
    transform: "rotate(22 12 12)"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FF7591",
    transform: "rotate(22 12 12)",
    xlinkHref: "#error_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#error_svg__b)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 15.333h-1.334V14h1.334v1.333zm0-2.666h-1.334v-4h1.334v4z"
  })))));
}
export default SvgError;